import { render } from "./TambahData.vue?vue&type=template&id=51173646&scoped=true"
import script from "./TambahData.vue?vue&type=script&lang=js"
export * from "./TambahData.vue?vue&type=script&lang=js"

import "./TambahData.vue?vue&type=style&index=0&id=51173646&scoped=true&lang=css"

import exportComponent from "/builds/christinandrea/kel1-kedaireka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51173646"]])

export default __exports__